import endpoints from '../endpoints'
import { type ApiV2QueryType } from '../types'
import { setAuthCookie } from '../setAuthCookie'

export default async function getReport({
  query,
  reportId,
}: {
  query?: ApiV2QueryType<unknown>
  reportId: string
}) {
  await setAuthCookie()
  const url = `${import.meta.env.VITE_RUUTS_API_URL}${endpoints.v2.reports.report(reportId)}?${new URLSearchParams(query as Record<string, string>).toString()}`
  window.open(url, '_blank')
  return url
}
